<template>
	<div class="leftres">
		<div>
			<div class="inputtop">
				<div v-for="(item, index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="seselect" :widthRight="item.widthRight" :widthLeft="item.widthLeft"
						:heightLeft="item.heightLeft" :heightRight="item.heightRight" :lablewith="item.lablewith"
						:options="item.options" :inputdata="item.inputdata" :title="item.title"
						:fontSize="item.fontSize" :color="item.color" :placeholder="item.placeholder"
						:types="item.types" :inputtype="item.inputtype" :width="item.width"></Commondropdownlist>
				</div>
				<div class="Btngroups">
					<CommonBtngroup :show="false" :qhide="false" @select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;"></div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Secondarydealerfilestable :tableData="tableData" :total="total" :invlist="formdata[2].options"
					@Export="Export" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange">
				</Secondarydealerfilestable>
			</div>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from "../../../components/common-dropdownlist.vue";
	import CommonBtngroup from "../../../components/commongroup.vue";
	import Dialog from "../../../components/dialog.vue";
	import Secondarydealerfilestable from "./components/secondarydealerfilestable.vue";
	import {
		InventoryClassList,
	} from '@/api/home'

	import {
		GetCustomerScoreList,
		ExportCustomerScore
	} from "@/api/newsapi";
	import utils from "../../../common/utils";
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Secondarydealerfilestable,
		},
		data() {
			return {
				showorhide: true,
				CusName: "",
				InvClass: "",
				Year: "",
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				formdata: [{
						inputdata: "",
						title: "经销商",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "input",
						width: "200px",
						lablewith: "102px",
					},
					{
						inputdata: "",
						title: "年份",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "text",
						inputtype: "datey",
						width: "350px",
						lablewith: "102px",
					},
					{
						inputdata: "",
						title: "产品线",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请选择",
						types: "",
						inputtype: "select",
						width: "210px",
						btx: true,
						options: [],
						lablewith: '90px',
						event: "invClass"
					},
				],
			};
		},
		mounted() {
			this.customerList();
			this.inventoryClassList();
		},
		methods: {
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.formdata[2].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[2].options.push(obj);
					})
				}
			},
			// 列表
			async customerList() {
				let {
					data,
					code
				} = await GetCustomerScoreList({
					CusName: this.CusName,
					InvClass: this.InvClass,
					Year: this.Year,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				if (code == 0) {
					this.total = data.Count;
					this.tableData = data.data;
				}
			},
			// 导出
			async customerExport() {
				const loading = this.$loading({
					lock: true,
					text: '导出中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await ExportCustomerScore({
					CusName: this.CusName,
					InvClass: this.InvClass,
					Year: this.Year,
					pageSize: this.pageSize,
					pageIndex: this.pageindex,
				});
				loading.close();
				if (resexprot) {
					utils.downloadFile(resexprot, "历年经销商评分报表", "xlsx");
				} else {
					// 返回json
					this.$message.warning("导出失败");
				}
			},
			Export() {
				this.customerExport();
			},
			reset() {
				this.$refs.seselect.map((item, index) => {
					item.modelvalue = "";
				});
			},
			select() {
				this.pageindex = 1;
				try {
					this.CusName = this.$refs.seselect[0].modelvalue;
					this.Year = this.$refs.seselect[1].modelvalue;
					this.InvClass = this.$refs.seselect[2].modelvalue;
					this.customerList();
				} catch (error) {
					this.customerList();
				}
			},
			handleCurrentChange(pageindex) {
				this.pageindex = pageindex;
				this.customerList();
			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie;
				this.customerList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 90px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 340px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 90px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>